module.exports = __webpack_public_path__ + "img/icon4.bb001586.png";